export default [
  {
    path: "/sos/:token/:regin",
    title: 'sos',
    meta:{
      title:'sos'
    },
    name:'expertList',
    component: () => import('@/views/sos/sos.vue')
  },
  {
    path: "/ensos/:token/:regin",
    title: 'sos',
    meta:{
      title:'sos'
    },
    name:'ensos',
    component: () => import('@/views/sos/ensos.vue')
  }
]
